import { Chip, Stack, Typography } from "@mui/material";
import { type GridColDef } from "@mui/x-data-grid";

import { MailAccount } from "api/memberPortal/mailList/mailList.types";
import { dataGridDateGetter } from "components/MUI/DataGrid/DataGrid.utils";
import SyncStatus from "features/memberPortal/mail/components/SyncStatus/SyncStatus";

export const mailListMembersColumns: GridColDef<MailAccount>[] = [
  {
    field: "name",
    headerName: "User",
    flex: 3,
    renderCell: ({ row }) => (
      <Stack sx={{ justifyContent: "center", height: "100%" }}>
        <Typography variant="body2">{row.name}</Typography>
        <Typography variant="caption" color="text.secondary">
          {row.email}
        </Typography>
      </Stack>
    ),
  },
  {
    field: "mailingListCount",
    headerName: "Mailing List",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: ({ row }) => (
      <Chip label={`${row.mailingListCount} Lists`} variant="outlined" />
    ),
  },
  {
    field: "createdOn",
    headerName: "Date Added",
    type: "date",
    flex: 1,
    valueGetter: dataGridDateGetter,
  },
  {
    field: "syncStatus",
    flex: 0,
    headerName: "Sync",
    headerAlign: "center",
    align: "center",
    renderCell: ({ value }) => <SyncStatus status={value} />,
  },
];
